import React from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight, faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { SettingsActions } from '../../../redux/Settings';
import Skill from './Skill';
import BaseContainer from '../../baseContainer';
import Title from '../../baseComponents/Title';
import Toggle from './Toggle';
import ClickableTitle from '../../baseComponents/ClickableTitle';

const SkillList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const SkillsContainer = () => {
  const dispatch = useDispatch();

  const {
    game,
    settings: { showActiveSkills, showPassiveSkills, showIncludedSkills },
  } = useSelector((state) => state);

  const {
    excludedSkills,
    includedSkills,
    excludedPassiveSkills,
    includedPassiveSkills,
  } = game.players[game.controlledPlayer];

  let ShowedSkills = [];
  let ShowedPassives = [];

  if (showIncludedSkills) {
    ShowedSkills = includedSkills.map((skill) => {
      return <Skill key={skill.name} skill={skill} />;
    });
    ShowedPassives = includedPassiveSkills.map((skill) => {
      return <Skill key={skill.name} skill={skill} />;
    });
  } else {
    ShowedSkills = excludedSkills.map((skill) => {
      return <Skill key={skill.name} skill={skill} />;
    });
    ShowedPassives = excludedPassiveSkills.map((skill) => {
      return <Skill key={skill.name} skill={skill} />;
    });
  }
  const ActiveSkillsIcon = (
    <FontAwesomeIcon icon={showActiveSkills ? faCaretRight : faCaretDown} />
  );
  const PassiveSkillsIcon = (
    <FontAwesomeIcon icon={showPassiveSkills ? faCaretRight : faCaretDown} />
  );
  return (
    <BaseContainer flexDirection="column">
      <Title text="Skills" />
      <Toggle />
      <SkillList>
        <ClickableTitle
          text="Active skills"
          icon={ActiveSkillsIcon}
          onClick={() =>
            dispatch(SettingsActions.setShowActiveSkills(!showActiveSkills))
          }
        />
        {showActiveSkills && ShowedSkills}
      </SkillList>
      <SkillList>
        <ClickableTitle
          text="Passive skills"
          icon={PassiveSkillsIcon}
          onClick={() =>
            dispatch(SettingsActions.setShowPassiveSkills(!showPassiveSkills))
          }
        />
        {showPassiveSkills && ShowedPassives}
      </SkillList>
    </BaseContainer>
  );
};

export default SkillsContainer;
